const demo_app = {
    title: 'شما با موفقیت وارد پیش‌نمایش زنده شدید!',
    subtitle: 'اطلاعات کاربری شما:',
    username: 'نام کاربری: ',
    user_id: 'شناسه کاربری: ',
    sign_out: 'خروج از پیش‌نمایش زنده',
    continue_explore: 'یا ادامه دهید به کاوش',
    customize_sign_in_experience: 'سفارشی‌سازی تجربه ورود',
    enable_passwordless: 'فعال‌سازی ورود بدون رمز عبور',
    add_social_connector: 'افزودن اتصال‌دهنده اجتماعی',
};
export default Object.freeze(demo_app);
